import Q from 'q';
class APIService {

    constructor() {
        this.requestCount = 0;
        this.errors = [];
    }

    get baseURL() {
        return 'https://api.lrepdocs.com'; // PRODUCTION
        // return 'https://lewisriceapi.tpidev7.com'; // TESTING
    }

    set apiKey(key) {
        this.key = key;
    }

    get apiKey() {
        return this.key;
    }

    get isWaiting() {
        return this.requestCount > 0;
    }

    get errorsOccurred() {
        return this.errors.length>0;

    }
    get errorList() {
        return this.errors;
    }

    resetErrors() {
        this.errors = [];
    }

    waitFor(promise, silentError) {
        var service = this;
        if (service.requestCount===0) service.resetErrors();
        service.requestCount++;
        return promise
            .catch(failure)
            .finally(function(){
                service.requestCount--;
            });

        function failure(xhr) {
            if (!silentError) {
                var messages = ['An unexpected error occurred.'];
                if ( xhr.statusText ) {
                    messages = [xhr.statusText];
                }
                if ( xhr.responseText ) {
                    xhr.responseJSON = JSON.parse(xhr.responseText);
                }
                if ( xhr.responseJSON ) {
                    if ( xhr.responseJSON.message ) {
                        messages = [xhr.responseJSON.message];
                    }
                    if ( xhr.responseJSON.error ) {
                        if ( xhr.responseJSON.error.message ) {
                            messages = [xhr.responseJSON.error.message];
                        }
                    }
                    if ( xhr.responseJSON.data ) {
                        if ( xhr.responseJSON.data.message ) {
                            messages = [xhr.responseJSON.data.message];
                        }
                        if ( xhr.responseJSON.data.form && xhr.responseJSON.data.form.children ) {
                            let children = xhr.responseJSON.data.form.children;
                            let errors = [];
                            for ( let child of Object.keys(children) ) {
                                if ( children[child].errors ) errors = errors.concat(children[child].errors);
                            }
                            if ( errors.length>0 ) messages = errors;
                        }
                    }
                }
                service.errors = service.errors.concat(messages);
            }
            throw xhr;
        }
    }

    defaultSettingsPlus(settings) {
        var defaults = {
            'async': true,
            'crossDomain': true,
            'method': 'GET'
        };
        if (this.apiKey) defaults.headers = {
            'X-Lewis-Rice-Api-Key': this.apiKey
        };
        return $.extend(defaults, settings);
    }

}

export default new APIService();


// WEBPACK FOOTER //
// ./src/services/api.service.js